import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";

export interface RawFilesBundleFile {
  key: string;
  type: "pdf" | "png" | "jpeg" | "text" | "json";
}

export type BundleIdentification = Pick<
  Tables<"raw_bundle_identifications">,
  "identified_type" | "confidence" | "identified_at"
>;

export interface RawFilesBundleRow {
  id: string;
  source: string;
  bucket: string;
  files: RawFilesBundleFile[];
  bundle_type: string | null;
  bundle_date: string | null;
  created_at: string;
  csn: string | null;
  bundle_revision: number | null;
  identification: BundleIdentification | null;
}

async function fetchBundlesForPatient(patientId: string): Promise<RawFilesBundleRow[]> {
  const { data, error } = await supabase
    .from("raw_files_bundles")
    .select(
      "id, source, bucket, files, bundle_type, bundle_date, created_at, csn:metadata->csn, bundle_revision:metadata->bundleRevision, identification:raw_bundle_identifications(identified_type, confidence, identified_at)",
    )
    .eq("patient_id", patientId)
    .order("bundle_date", { ascending: false });

  if (error) throw error;
  return data as unknown as RawFilesBundleRow[];
}

export function useBundlesForPatient(patientId: string | null) {
  return useQuery({
    queryKey: ["raw-files-viewer-bundles", patientId],
    queryFn: () => fetchBundlesForPatient(patientId!),
    enabled: !!patientId,
  });
}
